import {
  type OddsFormatPreferences,
  usePreferences,
} from "@/hooks/firestore/user/usePreferences";

const oddsFormatMap = {
  DECIMAL: "decimal",
  AMERICAN: "american",
  FRACTIONAL: "fractional",
} as const satisfies Record<
  OddsFormatPreferences,
  "decimal" | "american" | "fractional"
>;

const useOddsFormat = () => {
  const {
    preferences: { oddsFormat },
  } = usePreferences();

  return oddsFormatMap[oddsFormat ?? "DECIMAL"];
};

export { useOddsFormat };
